function renderCcpa() {

  if (typeof window.__uspapi === 'function') {
    window.__uspapi('uspPing', 1, function(obj, status) {
      if (status && obj.mode.includes('USP') && obj.jurisdiction.includes(obj.location.toUpperCase())) {
        let hamburger = document.getElementsByClassName('items-list scroll')
        hamburger[0].childNodes[hamburger[0].childNodes.length - 1].insertAdjacentHTML(
            'afterend',
            `<div class="items-list__item-name"><a onclick="window.__uspapi('displayUspUi')" class="items-list__link" href="#">Do Not Sell My Data</a></div>`
        )
        window.__uspapi('setUspDftData', 1, function(obj, status) {
          if (!status) {
            console.log("Error: USP string not updated!")
          }
        });
      }
    });
  }
}
export function init() {
  renderCcpa()
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/cookie_consent/cookieConsentUtils.js